var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        size: "lg",
        "no-close-on-esc": true,
        "no-close-on-backdrop": true,
        "hide-header-close": true
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _vm._v("\n    PDPA Consent\n  ")
      ]),
      _vm._v(" "),
      _vm.pdpaConsent
        ? _c("div", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h3", { staticClass: "text-center" }, [
                  _vm._v(_vm._s(_vm.pdpaConsent.name))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "py-4" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.pdpaConsent.detail) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _vm.pdpaConsent
                  ? _c(
                      "div",
                      { staticClass: "px-4" },
                      _vm._l(_vm.pdpaConsent.options, function(option) {
                        return _c("div", { staticClass: "d-flex pb-3" }, [
                          _c("div", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedOptions,
                                  expression: "selectedOptions"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: { type: "checkbox", id: option.id },
                              domProps: {
                                value: option,
                                checked: Array.isArray(_vm.selectedOptions)
                                  ? _vm._i(_vm.selectedOptions, option) > -1
                                  : _vm.selectedOptions
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.selectedOptions,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = option,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.selectedOptions = $$a.concat([
                                          $$v
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.selectedOptions = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.selectedOptions = $$c
                                  }
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "pl-2" }, [
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                attrs: { for: option.id }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(option.name) +
                                    "\n                "
                                ),
                                option.required
                                  ? _c("span", { staticClass: "text-danger" }, [
                                      _vm._v("*")
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ])
                        ])
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100 text-right",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer"
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-info btn-lg",
              attrs: { disabled: _vm.isLoading },
              on: {
                click: function($event) {
                  return _vm.saveUserPdpaConsent()
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.isLoading ? "กำลังโหลด..." : "บันทึก") +
                  "\n    "
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-83a0e540", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83a0e540","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/PdpaConsentModal.vue
// module id = 2002
// module chunks = 0